export * from './rgpd-dialog';
